import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

const CaseEnclosures = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [rows, setRows] = useState([
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Smith' },
    { id: 3, name: 'Michael Johnson' },
  ]);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  // Fetch case enclosures from backend when component mounts
  useEffect(() => {
    const fetchCaseEnclosures = async () => {
      try {
        const response = await fetch('https://hms.backend.hiragroupcloud.com/api/case-enclosures'); // Adjust the API endpoint as needed
        const data = await response.json();
        const formattedData = data.map((item) => ({
          id: item._id, // Assuming your backend returns `_id` for MongoDB, adjust if different
          name: item.valueName,
        }));
        setRows(formattedData);
      } catch (error) {
        console.error('Error fetching case enclosures:', error);
      }
    };

    fetchCaseEnclosures();
  }, []);

  const handleEdit = (id) => {

    const rowData = rows.find(row => row.id === id);

    setSelectedRowData(rowData);
    setIsEditModalOpen(true); // Open the modal when editing
  };

  // Close the edit modal
  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedRowData(null); // Clear selected row data when closing modal
  };

  const handleInputChange = (e) => {
    setSelectedRowData({ ...selectedRowData, [e.target.name]: e.target.value });
  };

   // Delete selected row
   const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://hms.backend.hiragroupcloud.com/api/deleteEnclosures/${id}`);


      if (response.data.success) {
        // Remove the deleted row from the state
        setRows(rows.filter(row => row.id !== id));
        setSelectedRowId(null);
        
      } else {
        console.error("Failed to delete account:", response.data.message);
      }
    } catch (error) {
      console.error('There was an error deleting the account:', error);
    }
  };

  const handleRowClick = (id) => {
    setSelectedRowId(id === selectedRowId ? null : id);
  };

  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const handleSaveChanges = async (id) => {
    if (!selectedRowData) {
      console.error("Selected row data is missing");
      return;
    }
    
    const updatedRowData = {
      _id: selectedRowData.id,
      valueName: selectedRowData.name
    }
    try {
      // Make an API call to save the changes
      const response = await axios.put(`https://hms.backend.hiragroupcloud.com/api/updateEnclosure/${updatedRowData._id}/`, updatedRowData);
      
  
      if (response.data.success) {
        // After successfully saving the data, update the rows state
        const updatedRows = rows.map(row =>
          row.id === selectedRowData.id ? { ...row, ...selectedRowData } : row
        );
        setRows(updatedRows); // Update the rows in the state
        setIsEditModalOpen(false);
        setSelectedRowData(null); // Reset the selected row data
      } else {
        console.error("Failed to save changes:", response.data.message);
      }
    } catch (error) {
      console.error('There was an error saving the data:', error);
    }
  };
    

  return (
    <>
      <h1 className="title" style={{ border: 'white', borderBottom: '3px solid #004aad', padding: '10px' }}>Case Enclosures</h1>
      <div
        className="search">
        <div className="row align-items-center">
          <div className="col-md-9 d-flex justify-content-between">
            <div className="col-md-3 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-3 d-flex justify-content-end">
            <Link to="/AddCaseEnclosure" className="btn btn-primary" style={{backgroundColor:"#004aad",borderColor:"#004aad"}}>
              Add
            </Link>
          </div>
        </div>
      </div>

      <div
        style={{ height: 350, width: '100%', position: 'relative', marginTop: '2%', background: '#f0f0f5' }}
      >
        <DataGrid
          rows={filteredRows}
          columns={[{ field: 'name', headerName: 'Name', width: 200 }]}
          pageSize={5}
          rowSelected={selectedRowId !== null}
          onRowClick={(row) => handleRowClick(row.id)}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex((row) => row.id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop: '15px',
            }}
          >
             <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
                  <Button
              variant="contained"
              sx={{ backgroundColor: 'red', '&:hover': { backgroundColor: '#c62828' } }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </Button>
          </div>
        )}
      </div>

      {/* Modal for Editing */}
      <Dialog open={isEditModalOpen} onClose={handleModalClose}>
        <DialogTitle>Edit Case Enclosure</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            name="name"
            value={selectedRowData?.name || ''}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleSaveChanges(selectedRowData.id)} color="primary">
            Save Change
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CaseEnclosures;
